export default class AuthService {

  login(token: string, userId: string) {
    sessionStorage.setItem('token', token)
    sessionStorage.setItem('userId', userId)
  }

  logout() {
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('userId')
  }
}
